export const ICON_COLOR = '#454546';
export const desktopVersionMinimumSize = 768;